import * as React from 'react';
import { fetchDeferredContentAction } from 'actions/deferredContentAction';
import { connect } from 'react-redux';
import Loader from 'components/Common/Loader/Loader';
import get from 'lodash/get';
import { LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import StringWidget from 'components/StringWidget';
export class DeferredContent extends React.Component {
    constructor() {
        super(...arguments);
        this.renderContent = () => {
            const response = get(this.props.deferredContent, [this.props.url]);
            if (!response)
                return null;
            switch (response.asyncStatus) {
                case LOADING:
                    return <Loader />;
                case ERROR:
                    return <StringWidget strKey="errortnc"/>;
                case SUCCESS:
                    const responseData = response.content;
                    if (!responseData)
                        return null;
                    switch (typeof responseData) {
                        case 'string':
                            return <div dangerouslySetInnerHTML={{ __html: responseData }}/>;
                        case 'object':
                            return Object.keys(responseData).map((item, id) => {
                                return <div key={item + id} dangerouslySetInnerHTML={{ __html: responseData[item] }}/>;
                            });
                        default:
                            return null;
                    }
                    break;
                default:
                    return null;
            }
        };
    }
    componentDidMount() {
        if (this.props.url) {
            const { url, id, requestToPayzippy, responseKey, fetchDeferredContent } = this.props;
            fetchDeferredContent({
                url,
                id,
                requestToPayzippy,
                responseKey
            });
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.url !== nextProps.url) {
            const { url, id, requestToPayzippy, responseKey, fetchDeferredContent } = nextProps;
            fetchDeferredContent({
                url,
                id,
                requestToPayzippy,
                responseKey
            });
        }
    }
    render() {
        return <div>{this.renderContent()}</div>;
    }
}
const mapStateToProps = (state) => {
    return {
        deferredContent: state.deferredContent
    };
};
const mapDispatchToProps = {
    fetchDeferredContent: fetchDeferredContentAction
};
export default connect(mapStateToProps, mapDispatchToProps)(DeferredContent);
